import { type ReactNode } from 'react';
import styles from './bordered-cta-container.module.scss';
import MarkdownParser from 'components/rich-text/markdown-parser';

const BorderedCtaContainer = ({
	title,
	description,
	color = 'var(--color-grey-900)',
	borderColor = 'var(--color-border)',
	backgroundColor,
	children,
}: IProps) => {
	const containerStyle = {
		...(borderColor ? { borderColor } : {}),
		...(backgroundColor ? { backgroundColor } : {}),
	};
	const titleStyle = {
		...(color ? { color } : {}),
	};

	return (
		<section className={styles.container} style={containerStyle}>
			{title && (
				<div className={styles.title} style={titleStyle}>
					<p>{title}</p>
				</div>
			)}
			{description && (
				<div className={styles.description}>
					<MarkdownParser>{description}</MarkdownParser>
				</div>
			)}
			{children}
		</section>
	);
};

interface IProps {
	title?: string;
	description?: string;
	color?: string;
	borderColor?: string;
	backgroundColor?: string;
	children: ReactNode | ReactNode[];
}

export default BorderedCtaContainer;
